import { render, staticRenderFns } from "./ViewUsers.vue?vue&type=template&id=04196cf1&"
import script from "./ViewUsers.vue?vue&type=script&lang=js&"
export * from "./ViewUsers.vue?vue&type=script&lang=js&"
import style0 from "./ViewUsers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports